module.exports = __webpack_public_path__ + "img/ufa-bet-support.3657b6ae.png";